import { render, staticRenderFns } from "./SyaratKetentuan-Desktop.vue?vue&type=template&id=779c7ceb&scoped=true"
import script from "./SyaratKetentuan-Desktop.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan-Desktop.vue?vue&type=script&lang=js"
import style0 from "./SyaratKetentuan-Desktop.vue?vue&type=style&index=0&id=779c7ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c7ceb",
  null
  
)

export default component.exports